import { Button, Modal, Tag, Typography, message } from "antd";
import DOWNLOAD_ICON from "../../../../statics/images/icon-download.svg";
import EYE_ICON from "../../../../statics/images/icon-eye.svg";
import COPY_ICON from "../../../../statics/images/icon-copy.svg";
import styles from "./styles.module.scss";
import { FC, useEffect, useState } from "react";
import useTransferAgreement, { Props } from "./hook";
import ClaimAgreeement from "../ClaimAgreeement";
import { decrypt, isJson } from "../../../../common/utils";
import moment from "moment-timezone";

// TODO: Add Submission status
export type ReceivedProps = Record<string, any>;

const TransferAgreementLayout: React.FC<Props> = ({
  claimData,
  transferAgreementData,
  toggleAgreementModal,
  exportAgreement,
  surveyData,
  openAgreement,
  messageApi,
  celciusScheduleData,
}) => {
  const [celsiusPassword, setCelsiusPassword] = useState<string>();

  const getCelsiusPassword = async () => {
    if (transferAgreementData && transferAgreementData!["celsius_password"]) {
      setCelsiusPassword(
        await decrypt(transferAgreementData!["celsius_password"])
      );
    }
  };

  const [newCelsiusPassword, setNewCelsiusPassword] = useState<string>("N/A");

  const getNewCelsiusPassword = async () => {
    if (transferAgreementData && transferAgreementData!["new_account_password"] !== "") {
      // New one, encoded     
      if (isJson(transferAgreementData!["new_account_password"])) {
        setNewCelsiusPassword(
          await decrypt(transferAgreementData!["new_account_password"])
        );
      } else { // Old one, not encoded
        console.log("Old one");
        setNewCelsiusPassword(transferAgreementData!["new_account_password"]);
      }
    }
  };

  useEffect(() => {
    getCelsiusPassword();
    getNewCelsiusPassword();
  }, [transferAgreementData]);

  return (
    <>
      <div className={styles["transfer-agreement"]}>
        <div className={styles["transfer-agreement__row"]}>
          <Typography.Text>Agreement Status</Typography.Text>
          <Tag
            className="fill"
            style={{
              backgroundColor: "#EDF3C8",
              color: "#98A933",
            }}
          >
            {(transferAgreementData &&
              transferAgreementData["agreement_status"]) ||
              "N/A"}
          </Tag>
        </div>

        <div className={styles["transfer-agreement__row"]}>
          <Typography.Text>Celsius Account Acquition Status</Typography.Text>
          <Tag
            className="outline"
            style={{
              color:
                transferAgreementData?.celsius_account_acquired !==
                "Account Acquired"
                  ? "#F04438"
                  : "#31B43E",
              border: "1px solid #E2E2E2",
              borderRadius: 36,
              padding: "5px 12px",
            }}
          >
            ●{" "}
            {transferAgreementData?.celsius_account_acquired !==
            "Account Acquired"
              ? "Account Not Acquired"
              : "Account Acquired"}
          </Tag>
        </div>
        <div className={styles["transfer-agreement__row"]}>
          <Typography.Text>Submission Status</Typography.Text>
          <Typography.Text>
            {transferAgreementData && transferAgreementData["submit_status"]}
          </Typography.Text>
        </div>

        <div className={styles["transfer-agreement__row"]}>
          <Typography.Text>Agreement Signed Date</Typography.Text>
          <Typography.Text>
            {transferAgreementData?.agreement_signed_time
              ? moment(transferAgreementData?.agreement_signed_time).format(
                  "MMMM Do YYYY, hh:mm:ss"
                )
              : "N/A"}
          </Typography.Text>
        </div>

        {transferAgreementData && transferAgreementData["celsius_email"] && (
          <div className={styles["transfer-agreement__row"]}>
            <Typography.Text>Celsius Account Email</Typography.Text>
            {transferAgreementData ? (
              <div>
                <Typography.Text>
                  {transferAgreementData["celsius_email"]}
                </Typography.Text>
                <Button
                  type="link"
                  style={{ padding: 0, marginLeft: 5 }}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      transferAgreementData["celsius_email"]
                    );
                    messageApi.info(
                      "Copied " + transferAgreementData["celsius_email"]
                    );
                  }}
                >
                  <img src={COPY_ICON} alt="COPY_ICON" />
                </Button>
              </div>
            ) : (
              "N/A"
            )}
          </div>
        )}

        {transferAgreementData && transferAgreementData["celcius_code"] && (
          <div className={styles["transfer-agreement__row"]}>
            <Typography.Text>Celsius Pin Code</Typography.Text>
            {transferAgreementData ? (
              <div>
                <Typography.Text>
                  {transferAgreementData["celcius_code"]}
                </Typography.Text>
                <Button
                  type="link"
                  style={{ padding: 0, marginLeft: 5 }}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      transferAgreementData["celcius_code"]
                    );
                    messageApi.info(
                      "Copied " + transferAgreementData["celcius_code"]
                    );
                  }}
                >
                  <img src={COPY_ICON} alt="COPY_ICON" />
                </Button>
              </div>
            ) : (
              "N/A"
            )}
          </div>
        )}

        {transferAgreementData && transferAgreementData["celsius_password"] && (
          <div className={styles["transfer-agreement__row"]}>
            <Typography.Text>Celsius Account Password</Typography.Text>
            <Typography.Text>
              {transferAgreementData &&
              transferAgreementData["celsius_password"]
                ? celsiusPassword
                : "N/A"}
            </Typography.Text>
          </div>
        )}

        {transferAgreementData &&
          transferAgreementData?.["new_account_email"] !== "" && (
            <div className={styles["transfer-agreement__row"]}>
              <Typography.Text>New Celsius Account Email</Typography.Text>
              <div>
                <Typography.Text>
                  {transferAgreementData &&
                  transferAgreementData?.["new_account_email"] !== "" &&
                  transferAgreementData?.celsius_account_acquired ===
                    "Account Acquired"
                    ? transferAgreementData?.["new_account_email"]
                    : "N/A"}
                </Typography.Text>
                {transferAgreementData &&
                  transferAgreementData?.["new_account_email"] !== "" &&
                  transferAgreementData?.celsius_account_acquired ===
                    "Account Acquired" && (
                    <Button
                      type="link"
                      style={{
                        padding: 0,
                        marginLeft: 8,
                      }}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          transferAgreementData["new_account_email"]
                        );
                        messageApi.info(
                          transferAgreementData["new_account_email"]
                        );
                      }}
                    >
                      <img src={COPY_ICON} alt="COPY_ICON" />
                    </Button>
                  )}
              </div>
            </div>
          )}

        {transferAgreementData &&
          transferAgreementData?.["new_account_password"] !== "" && (
            <div className={styles["transfer-agreement__row"]}>
              <Typography.Text>New Celsius Account Password</Typography.Text>
              <Typography.Text>
                {transferAgreementData &&
                transferAgreementData?.["new_account_password"] !== "" &&
                transferAgreementData?.celsius_account_acquired ===
                  "Account Acquired"
                  ? newCelsiusPassword
                  : "N/A"}
              </Typography.Text>
            </div>
          )}

        {/* <div className={styles['transfer-agreement__row']}>
                  <Typography.Text>Agreement signature</Typography.Text>
                  {transferAgreementData && transferAgreementData["signature"] && (
                    <img
                      height={70}
                      src={transferAgreementData["signature"]}
                      alt="SIGNATURE"
                    />
                  )}
              </div> */}
        <div className={styles["transfer-agreement__row"]}>
          <Typography.Text>Transfer Agreement</Typography.Text>
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "center",
            }}
          >
            <Button
              className={"file-action"}
              type="link"
              onClick={toggleAgreementModal}
            >
              <img src={EYE_ICON} alt="EYE_ICON" />
              View Agreement Content
            </Button>
            <Button
              className={"file-action"}
              type="link"
              onClick={exportAgreement}
            >
              <img src={DOWNLOAD_ICON} alt="DOWNLOAD_ICON" />
              Download Agreement
            </Button>
          </div>
        </div>
      </div>
      <Modal
        open={!!openAgreement}
        onCancel={toggleAgreementModal}
        centered
        footer={false}
        bodyStyle={{ height: "80vh" }}
        width={"80vw"}
      >
        <ClaimAgreeement
          claim={claimData}
          survey={surveyData}
          celciusScheduleData={celciusScheduleData}
        />
      </Modal>
    </>
  );
};

const TransferAgreement: FC<ReceivedProps> = () => (
  <TransferAgreementLayout {...useTransferAgreement()} />
);

export default TransferAgreement;
